import Vue from 'vue'
import FloatAd from '@/components/app/adsense/float_ad.vue'
import MessageBox from './index'
import { utils } from '@/libs/interfaces'

/** 联调 mock：true 时点击红包弹窗跳过支付；上线保持 false */
export const MINE_REDBAG_MOCK_PAY_SUCCESS = false

export const MINE_REDBAG_IMG = 'https://qncweb.ktvsky.com/20260529/vadd/ae9f30bc668cab1187f0cd4e6e4f7b19.png'
export const MINE_HAPPY_ROOM_GUIDE_IMG = 'https://qncweb.ktvsky.com/20260529/vadd/0235e2b0a5bcc1fabc07b800730b5256.png'
/** 我的页红包流程专用右下角浮窗图（不影响其他位置 FloatAd） */
export const MINE_HAPPY_ROOM_FLOAT_IMG = 'https://qncweb.ktvsky.com/20260529/vadd/733a2004a30f3b0a715881eba3ff61c0.png'
const MINE_FLOAT_RIGHT = 28
const MINE_FLOAT_BOTTOM_VW = 33.333

function getMineFloatBottomPx() {
  return (window.innerWidth * MINE_FLOAT_BOTTOM_VW) / 100
}
const HAPPY_ROOM_IOS_APP_URL = 'https://apps.apple.com/us/app/%E6%AC%A2%E4%B9%90%E6%AD%8C%E6%88%BF/id6748891695'
const HAPPY_ROOM_YYB_APP_URL = 'https://sj.qq.com/appdetail/com.thunder.tv?&from_wxz=1'
const CLOSE_IMG = 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png'
const MINE_FLOAT_WRAPPER_ID = 'mine-happy-room-float-ad'

let mineHappyRoomFloatVm = null

function getMineHappyRoomFloatCookieKey() {
  const today = new Date().toISOString().slice(0, 10)
  return `mine_redbag_float_${today}`
}

/** 浮窗展示后写入 cookie，当日再次进入我的页可恢复 */
export function markMineHappyRoomFloatShown() {
  utils.cookie.setCookie('1', 1, getMineHappyRoomFloatCookieKey())
}

/** 我的页红包弹窗配置 */
export function getMineRedbagPopupConfig({ role }) {
  return {
    redbagImg: MINE_REDBAG_IMG,
    page_tp: `mine_popup_${role}`,
  }
}

function isIOSDevice() {
  return /iPad|iPhone|iPod/i.test(window.navigator.userAgent)
}

export function jumpToHappyRoomAppStore({ action }) {
  try {
    Vue.$sendLog({
      event_type: 'click',
      event_name: '欢乐歌房入口点击',
      event_data: { action },
    })
  } catch (e) {
    // ignore
  }
  if (isIOSDevice()) {
    window.location.href = HAPPY_ROOM_IOS_APP_URL
    setTimeout(() => {
      if (!document.hidden) {
        window.location.href = HAPPY_ROOM_YYB_APP_URL
      }
    }, 2500)
  } else {
    window.location.href = HAPPY_ROOM_YYB_APP_URL
  }
}

export function createShrinkAnim({
  imgUrl,
  fromRect,
  toRect,
  onComplete,
}) {
  if (!fromRect || !toRect) {
    if (typeof onComplete === 'function') onComplete()
    return
  }

  const el = document.createElement('img')
  el.src = imgUrl
  el.style.position = 'fixed'
  el.style.zIndex = '10001'
  el.style.left = `${fromRect.left}px`
  el.style.top = `${fromRect.top}px`
  el.style.width = `${fromRect.width}px`
  el.style.height = `${fromRect.height}px`
  el.style.borderRadius = '20px'
  el.style.transition = 'left 380ms cubic-bezier(0.2, 0.8, 0.2, 1), top 380ms cubic-bezier(0.2, 0.8, 0.2, 1), width 380ms cubic-bezier(0.2, 0.8, 0.2, 1), height 380ms cubic-bezier(0.2, 0.8, 0.2, 1), opacity 380ms ease'
  el.style.transformOrigin = 'center center'
  el.style.pointerEvents = 'none'

  document.body.appendChild(el)

  const finish = () => {
    el.removeEventListener('transitionend', finish)
    if (el && el.parentNode) el.parentNode.removeChild(el)
    if (typeof onComplete === 'function') onComplete()
  }

  requestAnimationFrame(() => {
    el.style.left = `${toRect.left}px`
    el.style.top = `${toRect.top}px`
    el.style.width = `${toRect.width}px`
    el.style.height = `${toRect.height}px`
    el.style.opacity = '1'
  })

  el.addEventListener('transitionend', finish)
  setTimeout(finish, 450)
}

const GUIDE_SHRINK_DURATION_MS = 680
const GUIDE_SHRINK_EASING = 'cubic-bezier(0.22, 0.61, 0.36, 1)'

/** 收起动画终点：页面右下角，与浮窗一致 bottom: 33.333vw */
function getGuideShrinkEndPoint(fromRect) {
  const targetBRX = window.innerWidth - MINE_FLOAT_RIGHT
  const targetBRY = window.innerHeight - getMineFloatBottomPx()
  return {
    translateX: targetBRX - (fromRect.left + fromRect.width),
    translateY: targetBRY - (fromRect.top + fromRect.height),
  }
}

/**
 * 欢乐歌房引导弹窗收起：以右下角为锚点移向页面右下并缩至 0，结束后展示浮窗
 */
export function createGuideShrinkToFloatAnim({
  imgUrl,
  fromRect,
  onReady,
  onComplete,
}) {
  if (!fromRect) {
    if (typeof onComplete === 'function') onComplete()
    return
  }

  const { translateX, translateY } = getGuideShrinkEndPoint(fromRect)

  const el = document.createElement('img')
  el.src = imgUrl
  el.style.position = 'fixed'
  el.style.zIndex = '10002'
  el.style.left = `${fromRect.left}px`
  el.style.top = `${fromRect.top}px`
  el.style.width = `${fromRect.width}px`
  el.style.height = `${fromRect.height}px`
  el.style.borderRadius = '20px'
  el.style.opacity = '1'
  el.style.transformOrigin = '100% 100%'
  el.style.transform = 'translate(0, 0) scale(1)'
  el.style.willChange = 'transform, opacity'
  el.style.transition = [
    `transform ${GUIDE_SHRINK_DURATION_MS}ms ${GUIDE_SHRINK_EASING}`,
    `opacity ${GUIDE_SHRINK_DURATION_MS}ms ease`,
  ].join(', ')
  el.style.pointerEvents = 'none'

  let finished = false
  function finishShrink() {
    if (finished) return
    finished = true
    if (el && el.parentNode) el.parentNode.removeChild(el)
    if (typeof onComplete === 'function') onComplete()
  }

  const runTransition = () => {
    document.body.appendChild(el)
    // eslint-disable-next-line no-unused-expressions
    el.offsetWidth
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (typeof onReady === 'function') onReady()
        el.style.transform = `translate(${translateX}px, ${translateY}px) scale(0)`
        el.style.opacity = '0'
      })
    })
  }

  if (el.complete) {
    runTransition()
  } else {
    el.onload = runTransition
    el.onerror = runTransition
  }

  el.addEventListener('transitionend', (e) => {
    if (e.target !== el || e.propertyName !== 'transform') return
    finishShrink()
  }, { once: true })
  setTimeout(finishShrink, GUIDE_SHRINK_DURATION_MS + 120)
}

export function destroyMineHappyRoomFloat() {
  if (!mineHappyRoomFloatVm) return
  try {
    mineHappyRoomFloatVm.$destroy()
    if (mineHappyRoomFloatVm.$el && mineHappyRoomFloatVm.$el.parentNode) {
      mineHappyRoomFloatVm.$el.parentNode.removeChild(mineHappyRoomFloatVm.$el)
    }
  } catch (e) {
    // ignore
  } finally {
    mineHappyRoomFloatVm = null
  }
  const wrapper = document.getElementById(MINE_FLOAT_WRAPPER_ID)
  if (wrapper && wrapper.parentNode) {
    wrapper.parentNode.removeChild(wrapper)
  }
}

export function showMineHappyRoomFloat({
  $this,
  action = '我的页红包-收起浮窗',
}) {
  if (!$this || mineHappyRoomFloatVm) return

  const Ctor = Vue.extend(FloatAd)
  const el = document.createElement('div')
  el.id = MINE_FLOAT_WRAPPER_ID
  document.body.appendChild(el)

  mineHappyRoomFloatVm = new Ctor({
    store: $this.$store,
    router: $this.$router,
    propsData: {
      imgUrl: MINE_HAPPY_ROOM_FLOAT_IMG,
      from: 'mineRedbag',
      name: '我的页-欢乐歌房浮窗',
      position: 'right',
      showClose: false,
      jumpToAppStore: true,
      clickAction: action,
      disableConfirmPopup: true,
      floatTheme: 'mine-redbag',
    },
  })

  mineHappyRoomFloatVm.$mount(el)
  el.style.opacity = '0'
  el.style.transition = 'opacity 320ms ease'
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      el.style.opacity = '1'
    })
  })

  markMineHappyRoomFloatShown()
}

export function restoreMineHappyRoomFloatIfNeeded({ $this }) {
  if (!$this) return
  const stored = utils.cookie.getCookie(getMineHappyRoomFloatCookieKey())
  if (!stored) return
  showMineHappyRoomFloat({
    $this,
    action: '我的页红包-浮窗恢复',
  })
}

/** 引导弹窗关闭：收起至右下角浮窗位置后展示浮窗 */
export function shrinkGuideToMineFloat({
  imgUrl,
  fromRect,
  $this,
  action = '我的页红包-关闭引导',
}) {
  if (!$this) return

  createGuideShrinkToFloatAnim({
    imgUrl,
    fromRect,
    onReady: () => {
      MessageBox.close()
    },
    onComplete: () => {
      showMineHappyRoomFloat({
        $this,
        action,
      })
    },
  })
}

export function showMineHappyRoomGuidePopup({
  $this,
  action = '我的页红包-支付成功',
}) {
  let closed = false
  const closeToFloat = (rect) => {
    if (closed) return
    closed = true
    shrinkGuideToMineFloat({
      imgUrl: MINE_HAPPY_ROOM_GUIDE_IMG,
      fromRect: rect,
      $this,
      action: `${action}-关闭引导`,
    })
  }

  MessageBox.showGuide({
    onDownload: () => jumpToHappyRoomAppStore({ action: `${action}-点击引导` }),
    onClose: closeToFloat,
  })
}

export { CLOSE_IMG }
